import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Link, useParams } from "react-router-dom"

import { selectScopedByClient } from "../../stores/appSlice"
import { fetchAccountingBatch, selectAccountingBatch } from "../financials/accountingBatches/accountingBatchesSlice"

export default function AccountingBatchNav({ activeTab, scopedByAccountingBatch = false }) {
    const dispatch = useDispatch()
    const { clientId, accountingBatchId } = useParams()
    const accountingBatch = useSelector(selectAccountingBatch)
    const scopedByClient = useSelector(selectScopedByClient)

    // Fetch the accountingBatch we need for breadcrumb
    // TODO: we may be able to simply swap this out for the use selector based
    // on how we decide to finally load in the records from other components.
    useEffect(() => {
        if (accountingBatchId) {
            dispatch(fetchAccountingBatch(accountingBatchId))
        }
    }, [dispatch, accountingBatchId])

    const formatRoute = (newRoute) => {
        if (clientId) {
            if (accountingBatchId && scopedByAccountingBatch) {
                return `/clients/${clientId}/accounting_batches/${accountingBatchId}${newRoute}`
            } else {
                return `/clients/${clientId}/accounting_batches${newRoute}`
            }
        } else if (accountingBatchId) {
            return `/accounting_batches/${accountingBatchId}${newRoute}`
        }

        return `/accounting_batches${newRoute || ""}`
    }

    // If we are scoped by a client, we are looking at an end-user's view.
    // If we are not scoped by a client, we are looking at an admin's view.
    const renderHeader = () => {
        if (scopedByClient) {
            return scopedByAccountingBatch ? renderRecordHeader() : renderIndexHeader()
        }

        // Admin - Not scoped by client here
        return (
            <>
                <h2>
                    <Link to={() => `/clients/${clientId}/accounting_batches`}>Client Batches > </Link>
                </h2>
                <ul className="header-tab-nav" role="navigation">
                    <li>
                        <Link to={() => formatRoute("/")}>
                            <button type="link" className={`${activeTab === "list" ? "selected" : ""}`}>
                                All Client Batches
                            </button>
                        </Link>
                    </li>
                </ul>
            </>
        )
    }

    const renderRecordHeader = () => {
        return (
            <>
                <h2>
                    <Link to={() => `/clients/${clientId}/accounting_batches`}>Client Batches > </Link>
                    {`${accountingBatch?.batch_group ? accountingBatch?.batch_group?.name + ' > ' : ''} ${accountingBatch.batch_code}`}
                </h2>
                <ul className="header-tab-nav" role="navigation">
                    {/* Uknown if we need a dashboard for this page */}
                    {/* <li>
                        <Link to={() => formatRoute("/dashboard")}>
                            <button type="link" className={`${activeTab === "dashboard" ? "selected" : ""}`}>
                                Dashboard
                            </button>
                        </Link>
                    </li> */}

                    {/* <li>
                        <Link to={() => formatRoute("/subaccounts")}>
                            <button type="link" className={`${activeTab === "subaccounts" ? "selected" : ""}`}>
                                Subaccounts
                            </button>
                        </Link>
                    </li> */}

                    <li>
                        <Link to={() => formatRoute("/bills")}>
                            <button type="link" className={`${activeTab === "bills" ? "selected" : ""}`}>
                                Bills
                            </button>
                        </Link>
                    </li>
                </ul>
            </>
        )
    }

    const renderIndexHeader = () => {
        return (
            <>
                <h2>
                    <Link to={() => `/clients/${clientId}/accounting_batches`}>Client Batches </Link>
                </h2>
                <ul className="header-tab-nav" role="navigation">
                    {/* Uknown if we need dashboard */}
                    {/* <li>
                        <Link to={() => formatRoute("/dashboard")}>
                            <button type="link" className={`${activeTab === "dashboard" ? "selected" : ""}`}>
                                Client Batches Dashboard
                            </button>
                        </Link>
                    </li> */}
                    <li>
                        <Link to={() => formatRoute("")}>
                            <button type="link" className={`${activeTab === "list" ? "selected" : ""}`}>
                                All Client Batches
                            </button>
                        </Link>
                    </li>
                </ul>
            </>
        )
    }

    return <>{renderHeader()}</>
}
